/** @jsxImportSource @emotion/react */

import classNames from 'classnames';
import { resetAuthChecking } from 'modules/auth/store';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'store/store';
import { DivProps } from 'typings';
import UDLink from 'ud-ui/components/link';
import UDLogo from 'ud-ui/components/logo';
import UDText from 'ud-ui/components/text';

import AuthComponentsBillboard from '../components/billboard';
import * as S from './styles';

type Props = {
  title: string;
  subtitle: string;
  action?: {
    title: string;
    linkLabel: string;
    link: string;
  };
  children: React.ReactNode;
  contentClassName?: string;
  formContainerProps?: DivProps;
};

const AuthLayoutsMain = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const resetCode = useCallback(() => {
    dispatch(resetAuthChecking());
  }, [dispatch]);

  return (
    <S.Container>
      <div className="left">
        <div className="left-container">
          <UDLogo to={Pages.SIGN_IN} className="d-block header" />
          <div className="content">
            <S.FormContainer {...props.formContainerProps}>
              {props.title && props.subtitle && (
                <div className="d-flex flex-column justify-content-between header" style={{ gap: 10, marginBottom: 30 }}>
                  <UDText type="title-1" className="color-SurfaceWhite" style={{ fontFamily: 'SF Pro Text', fontWeight: 300 }}>
                    {props.title}
                  </UDText>
                  <UDText
                    type="callout"
                    style={{ fontFamily: 'SF Pro Text', lineHeight: '18px' }}
                    className="subtitle color-SurfaceWhite"
                  >
                    {props.subtitle}
                  </UDText>
                </div>
              )}
              <div className={classNames(props.contentClassName)}>{props.children}</div>
              {props.action && (
                <div className="mt-auto">
                  <S.AlreadyContainer>
                    <UDText type="subhead" className="color-SurfaceWhite">
                      {props.action.title}
                    </UDText>
                    <UDLink to={props.action.link} type="subhead" className="color-DarkYellow" onClick={resetCode}>
                      {props.action.linkLabel}
                    </UDLink>
                  </S.AlreadyContainer>
                </div>
              )}
            </S.FormContainer>
          </div>
          <div className="footer">
            <a className="link text subhead mr-6" href="https://imgameapp.ru/#organizer" target="_blank" rel="noreferrer">
              О приложении
            </a>
            <a className="link text subhead mr-6" href="https://imgameapp.ru/privacy-policy" target="_blank" rel="noreferrer">
              Политика конфиденциальности
            </a>
            <a className="link text subhead mr-6" href="https://imgameapp.ru/terms-and-conditions" target="_blank" rel="noreferrer">
              Условия использования
            </a>
          </div>
        </div>
      </div>
      <AuthComponentsBillboard className="right" />;
    </S.Container>
  );
};

export default AuthLayoutsMain;
